export default __webpack_public_path__ + "static/media/product-image-3.bf4bd232.jpg";